<template>
  <div class="ml-6 mt-1 mr-2">

    <!-- TODO: new component TaskKanbanListWrapper.vue -->
    <InlineTaskKanbanListWrapper :message="message" ref="taskWrapper" />

    <!-- <TaskSelector :value="message" :read-only="true" /> -->

    <!-- <pre class="mini-pre">{{commitmentById( message.goalId, message.commitmentId )}}</pre> -->
    <!-- <pre class="mini-pre">{{message.$state}}</pre> -->
  </div>
</template>

<script>
// import TaskSelector from '@/components/RoutineCreatorPage/Elements/TaskSelector';
import InlineTaskKanbanListWrapper from '@/components/Inline/InlineTaskKanbanListWrapper'

// TODO: Task not clickable?

// TODO: Check if task was deleted!!!

export default {
  props: {
    message: {}
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    focus() {
      this.$refs.taskWrapper.focus();
    }
  },
  components: {
    // TaskSelector,
    InlineTaskKanbanListWrapper,
  }
};
</script>

<style>
</style>
